import React from 'react';
import { PublicBrand } from './PublicAppHeader';
import './LegalPage.css';

export type LegalSection = { id: string; title: string; content: React.ReactNode };

export default function LegalPage({ title, introduction, sections }: {
  title: string; introduction: React.ReactNode; sections: LegalSection[];
}) {
  React.useEffect(() => { document.title = `${title} | Vibesplit`; }, [title]);
  return (
    <div className="vs-design legal-page">
      <a className="legal-skip" href="#legal-content">Skip to content</a>
      <header className="legal-header"><PublicBrand href="/" /></header>
      <main id="legal-content" className="legal-content" tabIndex={-1}>
        <h1>{title}</h1>
        <p className="legal-date">Last updated: September 19, 2026</p>
        <div className="legal-introduction">{introduction}</div>
        <nav className="legal-contents" aria-label="On this page">
          <h2>On this page</h2>
          <ol>{sections.map(section => <li key={section.id}><a href={`#${section.id}`}>{section.title}</a></li>)}</ol>
        </nav>
        {sections.map(section => (
          <section id={section.id} key={section.id} aria-labelledby={`${section.id}-heading`}>
            <h2 id={`${section.id}-heading`}>{section.title}</h2>{section.content}
          </section>
        ))}
      </main>
      <footer className="legal-footer"><nav aria-label="Legal and support">
        <a href="/privacy/policy">Privacy policy</a><a href="/terms">Terms of service</a><a href="/support">Support</a>
      </nav></footer>
    </div>
  );
}
